import { useMemo } from 'react';
import { useCategories } from '@/hooks/queries/useCategories';
import { useCustomCategories } from '@/hooks/queries/useCustomCategories';
import { buildCategoryIndexFromTaxonomy, type CategoryIndex } from '@/components/transactions/screen/categoryIndex';

/**
 * The category index for surfaces that list transactions outside the transactions screen (the space pages, the
 * send flow): the picker taxonomy plus the user's custom categories, so a tile or a dot there resolves the same
 * label, icon and color as the personal row does.
 */
export function useCategoryIndex(): CategoryIndex {
  const { data: parents } = useCategories();
  const { data: custom } = useCustomCategories(true);
  return useMemo(() => buildCategoryIndexFromTaxonomy(parents, [], custom), [parents, custom]);
}
